import React, { useState } from 'react';
import './qr-code-scanner.styles.scss';
import { QrReader } from 'react-qr-reader';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCameraRotate } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

const QrCodeScanner = ({
    onScanSuccess,
    onScanError
}) => {

    const screenSize = useSelector(state => state.contentData.screenSize);
    const [ data, setData ] = useState('No result');
    const [ cameraMode, setCameraMode ] = useState('environment'); 
    // 'user' for front camera, 'environment' for back camera
    const navigate = useNavigate();

    function switchMode() {
        // This function can be used to switch between camera modes if needed
        setCameraMode(prevMode => (
            prevMode === 'user' 
            ? 'environment' 
            : 'user'
        ));
    }


    return (
        <div className={`qr-code-scanner ${screenSize}`}>
            {/* <div className='g-card scanner-card'> */}
                {/* <div className="card-title with-button">
                    Scan Player Code */}
                    
                {/* </div> */}
                {/* <hr /> */}
                <div>Scan a player's QR Code to easily distribute rewards!</div>
                <div className="g-space-1"></div>
                {
                    (cameraMode) &&
                    <QrReader
                        onResult={(result, error) => {
                        if (!!result) {
                            if (window.navigator.vibrate) {
                                window.navigator.vibrate(200); // Vibrate for 200ms
                            } else {
                                alert('Vibration not supported');
                            // Vibration is not supported
                            }
                            setData(result?.text);
                            onScanSuccess && onScanSuccess(result?.text);
                            // navigate(`../distribute?p=${result?.text}`);
                        }

                        if (!!error) {
                            // console.info(error);
                            // onScanError && onScanError(error);
                        }
                        }}
                        containerStyle={{ 
                            width: '100%', 
                            // borderRadius: '0.7rem' 
                        }}
                        constraints={{ facingMode: cameraMode }}
                    />
                }
                <button onClick={switchMode} className="g-button">
                    <FontAwesomeIcon icon={faCameraRotate} />
                    Switch Camera
                </button>
                
            {/* </div> */}
        </div>
    )
}

export default QrCodeScanner